import * as React from 'react';
import CommunicationContainer from '../containers/CommunicationContainer';
import Exercise from '../containers/Exercise';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Shell = _ref => {
  let {
    callbacks,
    environment,
    exercise,
    id,
    user
  } = _ref;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(CommunicationContainer, {
    exercise: exercise,
    exerciseId: id,
    onExerciseReady: callbacks.onExerciseReady,
    onExerciseStatusUpdate: callbacks.onExerciseStatusUpdate,
    onExerciseSubmitted: callbacks.onExerciseSubmitted,
    onXpUpdated: callbacks.onXpUpdated
  }), ___EmotionJSX(Exercise, {
    environment: environment,
    exercise: exercise,
    exerciseId: id,
    onExerciseFinished: callbacks.onExerciseFinished,
    onExerciseStatusUpdate: callbacks.onExerciseStatusUpdate,
    user: user
  }));
};
export default Shell;